$(document).on("turbo:load", () => {
  const step = $(".js-current-step").data("step");

  if (step) {
    $(`#${step}`)[0].scrollIntoView({ behavior: "smooth", block: "start" });
  }
});
